<div class="main-layout" [class.main-layout--ia-mode]="iaMode()">
  @if (data$ | async; as data) {
  @if (iaMode()) {
  <!-- APR-4028 — celular do IA mode: cabeçalho escuro com a marca e a cidade, conteúdo numa folha. -->
  <header class="ia-header">
    <div class="ia-header__bar">
      @if (!hideBackButton() || iaBack()) {
      <button type="button" class="ia-header__back" aria-label="Voltar" data-testid="layoutButtonBack" (click)="handleBackButtonOnClick()">
        <aprova-icon name="chevron-left-outline" size="24px" color="#ffffff" />
      </button>
      }
      <img class="ia-header__mark" src="/assets/images/aprova-marca-fundo-escuro.svg" alt="" />
      <span class="ia-header__brand">Aprova</span>
    </div>

    <div class="ia-header__city" data-testid="layoutMessageCity">
      @if (data.cityLogo) {
      <img [src]="data.cityLogo" alt="" width="20" height="20" />
      }
      <span>{{ data.cityName }}</span>
    </div>

    @if (iaStep(); as step) {
    <div class="ia-header__step" data-testid="layoutMessageStep">
      <span>Etapa {{ step.current }} de {{ step.total }} · {{ step.title }}</span>
      <div class="ia-header__bars" aria-hidden="true">
        @for (bar of stepBars(); track bar) {
        <span class="ia-header__bar-step" [class.ia-header__bar-step--done]="bar <= step.current"></span>
        }
      </div>
    </div>
    }
  </header>
  } @else {
  <div class="sidebar">
    <div class="sidebar__back-button" (click)="handleBackButtonOnClick()">
      @if (!hideBackButton()) {
      <aprova-icon name="chevron-left-outline" size="md" color="#06929F" />
      {{ isBackButtonHome() ? "Voltar para página inicial" : "Voltar" }}
      }
    </div>
    <div class="sidebar__city-infos">
      <div class="city-logo">
        @if(data.cityLogo){
        <img [src]="data.cityLogo" width="120" height="120" alt="logo" />
        }
      </div>
      <div class="sidebar__city-infos__divider"></div>

      <div>
        <div class="sidebar__city-infos__name">
          {{ data.cityName }}
        </div>
        <div class="sidebar__city-infos__phone">
          {{ data.cityPhone }}
        </div>
      </div>
    </div>

    <div class="sidebar__footer">
      <a href="https://aprova.com.br/" target="_blank">
        <span class="text-xs text-gray-600">Powered by</span>
         <!-- Outubro Rosa <img src="/assets/images/logo-rosa.svg" alt="aprova-logo" /> -->
         <img src="/assets/images/logo.svg" alt="aprova-logo" />
      </a>
    </div>
  </div>
  }
  }

  <div class="main-content" [class.has-error]="hasError()">
    @if (loading()) {
    <div class="main-content-loader">
      <aprova-loading-spinner [size]="40"></aprova-loading-spinner>

      <span class="app-loading__title">{{ loadingConfig().title }}</span>
      <span class="app-loading__subtitle">
        {{ loadingConfig().description }}
        <br />
        Por favor, aguarde.
      </span>
    </div>
    } @if(hasError()){
    <div class="login-error">
      <aprova-box-error
        [iconName]="errorConfig().iconName"
        [iconColor]="errorConfig().iconColor"
        [iconSize]="errorConfig().iconSize"
        [message]="errorConfig().message"
        [description]="errorConfig().description"
        [options]="errorConfig().options"
      >
        @if (errorConfig().action; as action) {
        <ng-container action>
          <aprova-button
            buttonType="button"
            buttonClass="btn-box-error border"
            class="w-full"
            [label]="errorConfig().actionText ?? ''"
            (click)="action()"
          />
        </ng-container>
        }
      </aprova-box-error>
    </div>
    } @else {
    <router-outlet></router-outlet>
    }
  </div>
</div>
